import React, { useCallback, useEffect, useState } from 'react'
import { Sidebar } from "../Sidebar/Sidebar";
import { GridDashBoard } from "../../style/Dashboard";
import { Navbar } from "../Navbar/Navbar";
import { Logo2 } from "../logo/Logo";
import "./Welcome.css"
import { Button } from "../../style/Button";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { NEW_AD_CREATIVE, NEW_CREATIVE_LOCATION, creativeConstants } from '../../constants';
import CustomizePopup from "../Home/CustomizePopup";
import { SettingIcon } from '../../style/Home';
import Setting from "../../assets/Pmc/setting.svg";
import DoctorImage from "../../assets/dr.thomas.png";
import { Grid } from '@material-ui/core';
import MobileNavbar from '../MobileNav/MobileNav';

const Welcome = () => {

  const [bannerType, setBannerType] = useState();
  const [drugType, setDrugType] = useState();
  const [open, setOpen] = React.useState(false);
  const [refresh, setRefresh] = useState(false);

  const history = useHistory();
  const checkAppointment = useCallback(
    () => history.push("/Calender"),
    [history]
  );

  const adConfig = localStorage.getItem("creativeConfig")
    ? JSON.parse(localStorage.getItem("creativeConfig"))
    : null;

  const getBannerType = () => {
    const len = adConfig ? adConfig.creative_size.length : 0;
    if (len === 0) return null;
    const newRandValue = Math.floor(Math.random() * len);
    return adConfig.creative_size[newRandValue];
  };

  const getDrugToShow = () => {
    if (!adConfig) return;
    const withCta = adConfig ? adConfig.creative_cta === "With CTAs" : null;

    // check all present 
    const allPresent = creativeConstants.messaging_sparks.every((element) => adConfig.messaging_sparks.includes(element));
    if (allPresent) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    // if any of rep or sample and copay
    const isPainfin = ['Rep', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element)) || ['Sample', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element));
    if (isPainfin) return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA

    // if drug, trail and copay all 3 present
    const isScleroderma = ['Drug', 'Trial', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element));
    if (isScleroderma) return withCta ? NEW_AD_CREATIVE.SCLERODERMA : NEW_AD_CREATIVE.SCLERODERMA_NO_CTA;

    // if only clinical and copay
    const isCareDura = ['Drug', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element));
    if (isCareDura) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA;

    return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA;
  }

  useEffect(() => {
    const bType = getBannerType();
    setBannerType(bType);

    const drugType = getDrugToShow();
    setDrugType(drugType);
  }, [refresh]);

  const handleClosePopup = () => {
    setOpen(false);
    setRefresh(!refresh);
  }

  return (
    <>
      <div className='noSidebar'>
        <MobileNavbar />
      </div>
      <GridDashBoard>
        <div className='desk-visibility'>
          <Grid container>
            <Grid item md={6}>
              <Logo2 />
            </Grid>
            <Grid item md={6} className='text-right'>
              <SettingIcon src={Setting} alt="setting" onClick={() => setOpen(true)} />
            </Grid>
          </Grid>
        </div>
        <div>
          <div className='bodySection'>
            {bannerType === "horizontal" && drugType &&
              <Grid md={12} className="hor-wrapper1" style={{ minHeight: "90px", textAlign: "center" }}>
                <div style={{ maxWidth: '728px', maxHeight: '90px', margin: '0 auto' }}>
                  <iframe
                    title="iframe"
                    srcDoc={NEW_CREATIVE_LOCATION[drugType].horizontal}
                    style={{
                      width: '100%',
                      height: '100%',
                      maxWidth: '728px',
                      maxHeight: '90px'
                    }}
                    frameBorder="0"
                    scrolling="no"
                  />
                </div>
              </Grid>
            }
            <Grid container className='mainWrapperContainer alignItemsCenter'>
              <Grid item md={3} sm={12} xs={12}>
                <div className="squ-wrapper">
                  {bannerType === "react" && drugType &&
                    <div  className="responsiveMargin" style={{ maxWidth: '300px', minHeight: '250px',}}>
                      <iframe
                        title="iframe"
                        srcDoc={NEW_CREATIVE_LOCATION[drugType].square} style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '300px',
                          minHeight: '250px'
                        }}
                        frameBorder="0"
                        scrolling="no"
                      />
                    </div>
                  }
                </div>
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <div className='welcomeWrapper'>
                  <div className="welcomeCard">
                    <p className='welcomeText'>Welcome to Doceree's Test EHR platform, <br /> Dr. Tom Collins</p>
                    <img className='docImage' src={DoctorImage} />
                    <Button
                      className=""
                      width="228px"
                      height="51px"
                      marginTop="30px"
                      style={{ fontWeight: 700, fontSize: "18px", alignSelf: 'center' }}
                      onClick={checkAppointment}
                    >
                      Check Appointments
                    </Button>
                  </div>
                </div>
              </Grid>
              <Grid item md={3} sm={12} xs={12}>
                <div className="ver-wrapper d-flex justify-content-end">
                  {bannerType === "vertical" && drugType &&
                    <div className='responsiveMargin' style={{ maxWidth: '300px', minHeight: '600px' }}>
                      <iframe
                        title="iframe"
                        srcDoc={NEW_CREATIVE_LOCATION[drugType].vertical}
                        style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '100%',
                          minHeight: '600px',
                          marginBottom: "30px"
                        }}
                        frameBorder="0"
                        scrolling="no"
                      />
                    </div>
                  }
                </div>
              </Grid>
            </Grid>
          </div>
          {open && <CustomizePopup open={open} onClose={handleClosePopup} />}
        </div>
      </GridDashBoard>
    </>
  );
}

export default Welcome